function EnrolleeProtocolRefresh() {
    "use strict";

    this.__type = 'EnrolleeProtocolRefresh:www.veritracks.com';
    this.Id = -1;
}
if (typeof exports !== 'undefined') {
    module.exports = EnrolleeProtocolRefresh;
}